import React, {useState} from 'react'
import Pal from './Pal'
import RadioOption from './ProfileCompletionComponents/RadioOption'
import fetchSideBarResponse from '../sidebarRequests';
import { ColorRing } from 'react-loader-spinner';

function PromptGetter({onClose, isVisible}) {

  const [promptType, setPromptType] = useState("");
  const [promptResponse, setPromptResponse] = useState("");
  const [displayQuestion, setDisplayQuestion]= useState(true);
  const [displayAnswer, setDisplayAnswer] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleRadioChange = (selectedOption)=>{
    console.log(selectedOption);
     setPromptType(selectedOption.value);
  }

  const handleGetPrompt = async() =>{
        if(promptType === ""){
            alert("Please select a valid option");
            return;
        }
        document.getElementById('main-sidebar-button').disabled = true;
        setIsLoading(true);
        const response = await fetchSideBarResponse("prompt", promptType);
        if(response){
          setIsLoading(false);
          setDisplayQuestion(false);
          setDisplayAnswer(true);
          setPromptResponse(response.response);
      }
  }

  const handleRetry = ()=>{
    setDisplayAnswer(false);
    setDisplayQuestion(true);
  }

  const handleClose= ()=> {
    handleRetry();
    onClose();
  }

  return (
    <div id = "pal-body"  style={{ display: isVisible ? 'flex' : 'none' }}>
    <Pal/>
    {displayQuestion && 
      <div id ="sidebar-question-container">
        <div id='pal-question'>
          What sort of prompt are you looking for?
        </div>
        <div id='pal-option'>
          <RadioOption value = "Poetry" onChangeFunc={handleRadioChange}/>
          <RadioOption value = "Prose" onChangeFunc={handleRadioChange}/>
        </div>
        {isLoading && <ColorRing
                                    visible={true}
                                    height="80"
                                    width="80"
                                    ariaLabel="blocks-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="blocks-wrapper"
                                    colors={[
                                    "#e15b64",
                                    "#f47e60",
                                    "#f8b26a",
                                    "#abbd81",
                                    "#849b87",
                                    ]}
                                />}
        <button className="form-submit-button" onClick= {handleGetPrompt} id='main-sidebar-button'>Get Prompt</button>
        <button class="form-submit-button" onClick= {handleClose} id='sidebar-button'>Close</button>
      </div>
    }
    {displayAnswer && <div id="promptResponse">
        {promptResponse}
        <button class="form-submit-button" onClick= {handleClose} id='sidebar-button-close'>Close</button>
        <button class="form-submit-button" onClick= {handleRetry} id='sidebar-button-retry'>Try Another</button>
    </div>}
</div>
  )
}

export default PromptGetter